import { Vue, Component } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { ROUTER } from "../../common/constants";
import { getAuthConfig } from "../../utils/auth-helper";
import { KANBAN_EVENTS } from "../../common/kanban.constant";
import { PropertyServices } from "../../services";
import { namespace } from "vuex-class";
import { storeModules } from "../../store";
import { Locale } from "../../models/locale-model";
import propertyEditTypesStore from "../../store/property/edit/property-edit-types.store";
import { IPropertyModel } from "../../models/property";
import { PropertyEditModule } from "../../store/property/edit";
import moduleConstant from "../../common/module-constant";
import { generateNewTabId } from "../../utils/cached-data";
import KanbanStoreTypes  from "../../store/kanban/kanban-types.stores";
// import { PropertyModel } from "../../models/property";

const CommonAction = namespace(storeModules.Common, Action);
const PropertyAction = namespace(storeModules.PropertyEdit, Action);
const PropertyGetter = namespace(storeModules.PropertyEdit, Getter);
const KanbanMutation = namespace(storeModules.Kanban, Mutation);
const KanbanGetter = namespace(storeModules.Kanban, Getter);

@Component({
	name: ROUTER.KANBAN,
	template: require("./template.html"),
	components: {
		'relation': () => import('../property/components/relation/RelationComponent.vue')
	}
})
export default class KanbanWebsite extends Vue {
	@CommonAction('setAgendaPrefetchProperty') private storeSetAgendaPrefetchProperty: (payload: { Id: number, Info: Object }) => Promise<any>;
    @PropertyAction(propertyEditTypesStore.Get.PROPERTY)
    storeGetPropertyById: (payload: {
        locales: Locale[];
        langCode: string;
        propertyId: number;
        loadTabs: string[];
    }) => Promise<IPropertyModel>;
	@PropertyGetter property: IPropertyModel;

	@KanbanMutation(KanbanStoreTypes.Set.KANBAN_URL)
	storeGetKanbanUrl: (payload: string ) => Promise<string>;
	@KanbanMutation(KanbanStoreTypes.Set.KANBAN_AUTHENTICATION)
	storeGetKanbanAuthentication: (payload: { auth: any }) => Promise<string>;

	@KanbanGetter kanbanUrl: string;
	@KanbanGetter kanbanAuthentication: any;

	isLoading = true;
	propertyService: PropertyServices = new PropertyServices();
	kanbanWebsiteUrl = ''

	// This is for create new relation in property detail view
	// propertyDetail: any = null;

	async created() {
		this.$registerModule(storeModules.PropertyEdit, new PropertyEditModule())
	}

	async mounted() {
		this.isLoading = true;		
		const authState = await this.authenticateAndLoadKanbanApp();
	
		if (this.kanbanAuthentication) {
			if (authState.oauth2.accessToken === this.kanbanAuthentication?.oauth2?.accessToken && this.kanbanUrl) {
				await this.storeGetKanbanUrl(this.kanbanUrl);
			} else {
				// Get the new token
				const encodedAuthState = encodeURIComponent(JSON.stringify(authState));
				await this.storeGetKanbanUrl(`${this.kanbanUrl}?auth_state=${encodedAuthState}`);
				await this.storeGetKanbanAuthentication({ auth: authState });
			}
		} else {
			// Get the new token
			const encodedAuthState = encodeURIComponent(JSON.stringify(authState));
			await this.storeGetKanbanUrl(`${this.kanbanUrl}?auth_state=${encodedAuthState}`);
			await this.storeGetKanbanAuthentication({ auth: authState });
		}

		this.kanbanWebsiteUrl = this.kanbanUrl
		
        this.handleMessage = this.handleMessage.bind(this);
		window.addEventListener("message", this.handleMessage);
	}

	get coPropertyDetail() {
		return this.property;
	}

	set coPropertyDetail(value: any) {
		this.property = value || null;
	}

	get allowLocales() {
        return Vue.config["locales"].filter(l => {
            return l.id != 4;
        });
    }

	get authConfig() {
		return getAuthConfig();
	}

	async authenticateAndLoadKanbanApp() {
		try {
			const authState = this.authConfig as any;
			if (!authState?.oauth2?.accessToken) {
				console.error("Authentication failed: Missing access token.");
				this.$message.error('Authentication failed: Missing access token.');
				return;
			}

			return authState;
		} catch (error) {
			console.error("Error authenticating and loading email app:", error);
			this.$message.error('Error authenticating and loading email app.');
		}
	}

	// Event handler when the iframe finishes loading
	onIframeLoad() {
		this.isLoading = false;
	}

	async handleMessage(event: MessageEvent) {
		console.log('HandleMessage', event)
		const { data } = event;
		const TYPE = data?.TYPE;
		const { type } = data

		const MessageType = TYPE || type

		switch (MessageType) {
			case KANBAN_EVENTS.URL_CHANGE: {
				const {VALUE} = data;
				const authState = this.authConfig as any;
				if (!authState?.oauth2?.accessToken) {
					console.error("Authentication failed: Missing access token.");
					// this.isLoading = false;
					return;
				}

				const currentUrlObj = new URL(this.kanbanUrl)
				const currentUrl = currentUrlObj?.pathname + currentUrlObj?.search
				if (currentUrl === VALUE) {
					return;
				} else {
					const newUrl = `${currentUrlObj?.origin+VALUE}`;
					await this.storeGetKanbanUrl(newUrl);
				}


				// Load the property detail
				if (VALUE.includes('lead-details')) {
					const id = VALUE.split('id=')
					await this.storeGetPropertyById({
						locales: this.allowLocales,
						langCode: this.$i18n.locale,
						propertyId: parseInt(id[1]),
						loadTabs: ["*"]
					})
				} else {
					this.coPropertyDetail = null;
				}
				break;
			}
			case KANBAN_EVENTS.VIEW_PERSON: {
				const { ID } = data;
				if (ID) {
					this.$router.push({
						name: ROUTER.CLIENT.CLIENT_VIEW,
						params: { id: ID.toString() },
					});
				}
				break;
			}

			case KANBAN_EVENTS.EDIT_PERSON: {
				const { ID } = data;
				if (ID) {
					this.$router.push({
						name: ROUTER.CLIENT.CLIENT_EDIT,
						params: { id: ID.toString() },
					});
				}
				break;
			}

			case KANBAN_EVENTS.NEW_RELATION: {
				(this as any).$refs.propertyRelations.newRelation();
				break;
			}

			case KANBAN_EVENTS.CREATE_APPOINTMENT: {
				const { ID } = data;
				if (ID) {
					console.log('this is coPropertyDetail', {
						Id: this.coPropertyDetail.Id,
						Info: {
							VisitingHours: this.coPropertyDetail?.Visitinghours,
							Reference: this.coPropertyDetail?.Reference
						}
					})
					this.storeSetAgendaPrefetchProperty({
						Id: this.coPropertyDetail.Id,
						Info: {
							VisitingHours: this.coPropertyDetail?.Visitinghours,
							Reference: this.coPropertyDetail?.Reference
						}
					}).then(() => {
						this.$router.push({
							name: ROUTER.AGENDA.AGENDA,
						})
					})
				}
				break;
			}

			case KANBAN_EVENTS.PROPERTY_EDIT: {
				const { ID } = data;
				if (ID) {
					this.$router.push({
						name: ROUTER.PROPERTY.PROPERTY_EDIT,
						params: { id: ID.toString() },
					});
				}
				break;
			}

			case KANBAN_EVENTS.CREATE_TASK: {
				const { data: { propertyId, personId, title, personReference } } = data;
				if (propertyId) {
					if (personId) {

						this.$router.push({
							name: ROUTER.TASK.TASK_NEW,
							params: { id: generateNewTabId(moduleConstant.Task) },
							query: {
								personId: personId.toString(),
								personRef: personReference.toString() || '',
								propertyId: propertyId.toString(),
								propertyRef: this.coPropertyDetail.Reference || '',
								subject: title || ''
							}
						});
					}

				}
				break;
			}

			default: break;
		}
	}

	refreshIframe() {
		// const iframe = (document.getElementById('kanbanIframe') as HTMLIFrameElement)
		// iframe.contentWindow?.location.reload()
	}

	beforeDestroy() {
		window.removeEventListener("message", this.handleMessage);
	}
}
